import clsx from 'clsx';

import type { FC, HTMLAttributes, ReactNode } from 'react';

import s from './ApptStatus.module.css';

type ApptStatusProps = HTMLAttributes<HTMLDivElement> & {
  Icon: ReactNode;
  textClassName?: string;
};

const ApptStatus: FC<ApptStatusProps> = ({ children, className, Icon, textClassName, ...props }) => (
  <div className={clsx(s.status, className)} {...props}>
    {Icon}
    <p className={clsx('note', s.text, textClassName)}>{children}</p>
  </div>
);

export { ApptStatus };
